import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Levels in the source room",
  description: "Levels are shown in the source room with different postions of sound source.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-3.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
